require("../app/page_switch.coffee")

window.pageInitFlag = false

pageInit = ->
  new window.PageSwitch()

$(document).ready ->
  if window.pageInitFlag != true
    pageInit()
  window.pageInitFlag = true


// WEBPACK FOOTER //
// ./assets/javascripts/pages/department.coffee